import { useCreatedReport } from '@app/modules/audit/modules/global-audit/hooks/useCreatedReport';
import { Report } from '@mi-front/core';
import { QueryView } from '@mi-front/ui';
import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router-dom';
import { BaseReportPage } from '../common/BaseReportPage';
import { ReportHeaderActions } from '../common/ReportHeaderActions';
import { ReportsViewPageSkeleton } from '../common/ReportsViewPageSkeleton';
import { VIEW_MAP } from './ViewMap';

export function ReportsViewPage() {
  const { id: reportId } = useParams<{ id: string }>();
  const reportQuery = useCreatedReport(reportId);

  return (
    <QueryView query={reportQuery} loader={<ReportsViewPageSkeleton />}>
      {(report: Report) => {
        const View = VIEW_MAP[report.type];

        if (!View) {
          return (
            <div>
              <FormattedMessage
                id="audit.reports.viewNotFound"
                defaultMessage="View not found for report {type}"
                values={{ type: report.type }}
              />
            </div>
          );
        }

        return (
          <BaseReportPage report={report} headerActions={<ReportHeaderActions report={report} />}>
            <View report={report} />
          </BaseReportPage>
        );
      }}
    </QueryView>
  );
}
